import axios from "axios";

import { IP } from "utils/Host";

export function zablokujZadanie(
  targetId,
  zablokowany,
  proces_nazwa_id,
  refreshGantAll,
) {
  axios
    .put(IP + "API_0019_zablokuj_zadanie/" + sessionStorage.getItem("token"), {
      targetId,
      zablokowany,
      oprawa: proces_nazwa_id,
    })
    .then((res) => {
      refreshGantAll();
    });
}
